import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule, JsonpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExamPlayerService } from '../_services/ExamPlayerService';
import { ReviewComponent } from './app.review.component';

@NgModule({
    imports: [BrowserModule, FormsModule, HttpModule],
    declarations: [ReviewComponent],
    exports: [ReviewComponent],
  providers: [ExamPlayerService],
})

export class TestReviewModule {
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Review/app.review.module.ts